import 'react-quill/dist/quill.snow.css';

import * as Yup from 'yup';

import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import React, { Component } from 'react';
import { showError, showInfo } from '../../actions/notificationActions';

import ReactQuill from 'react-quill';
import { callApi } from '../../utils';
import { closeAllModals } from '../../actions/modalActions';
import { connect } from 'react-redux';
import { startCase } from 'lodash';

export default connect((state) => ({
  open: state.modals.createCareer,
  data: state.modals.data,
}))(
  class CreateCareerModal extends Component {
    state = {
      loading: false,
      title: '',
      status: '',
      team: '',
      statuses: ['Draft', 'Open', 'Closed'],
      error: '',
      teams: [
        'engineering',
        'customer_support',
        'marketing',
        'hr',
        'sales',
        'other',
      ],
      excerpt: '',
      description: '',
      errors: [],
    };

    setInput = (e) => {
      const { name, value } = e.target;
      this.setState({ [name]: value });
    };

    handleDescriptionChange = (content) => {
      this.setState({ description: content });
    };

    close = () => {
      this.props.dispatch(closeAllModals());
    };

    submit = async (e) => {
      e.preventDefault();
      const schema = Yup.object().shape({
        title: Yup.string().required('Title is required').trim(),
        team: Yup.string()
          .required('Team is required')
          .trim()
          .oneOf(this.state.teams),
        status: Yup.string()
          .required('Status is required')
          .trim()
          .oneOf(
            this.state.statuses.map((status) => status.toLocaleLowerCase())
          ),
        excerpt: Yup.string().required('Excerpt is required').trim(),
        description: Yup.string().required('Description is required').trim(),
      });

      try {
        let validForm = await schema.isValid(this.state);
        if (!validForm) {
          await schema.validate(this.state, {
            abortEarly: false,
          });
        }
      } catch (error) {
        this.setState({ errors: error.errors });
        return;
      }

      let bodyObj = {
        title: this.state.title,
        team: this.state.team,
        status: this.state.status,
        description: this.state.description,
        excerpt: this.state.excerpt,
      };

      this.setState({ loading: true });

      callApi('/careers', bodyObj, 'post')
        .then((res) => {
          this.setState({ loading: false });
          this.props.dispatch(showInfo(res.message));
          this.close();
          this.props.dispatch(closeAllModals());
          // this.props.refresh();
          // setTimeout(() => {
          // }, 2000);
        })
        .catch((err) => {
          this.setState({ loading: false });
          if ((err.status = 'unprocessable'))
            this.props.dispatch(showError(err.message));
        });
    };

    render() {
      const open = this.props.open;
      return (
        <div>
          <Modal size="lg" isOpen={open} toggle={this.close}>
            <ModalHeader toggle={this.close}>Create Job Listing</ModalHeader>
            <ModalBody>
              {this.state.errors.length > 0 ? (
                <ul>
                  {this.state.errors.map((error, index) => (
                    <li key={index} style={{ color: 'red' }}>
                      {error}
                    </li>
                  ))}
                </ul>
              ) : (
                ''
              )}
              <form>
                <div>
                  <FormGroup>
                    <Label className="mt-3">Title:</Label>
                    <Input
                      name="title"
                      type="text"
                      onChange={this.setInput}
                      value={this.state.title}
                      disabled={this.state.loading}
                    />
                  </FormGroup>

                  <Row>
                    <Col md={6} xs={12}>
                      <FormGroup>
                        <Label for="type">Status</Label>
                        <Input
                          id="status"
                          name="status"
                          type="select"
                          onChange={this.setInput}
                        >
                          <option value={''}>Please select</option>
                          {this.state.statuses.map((status, index) => (
                            <option
                              key={index}
                              value={status.toLocaleLowerCase()}
                            >
                              {startCase(status)}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col md={6} xs={12}>
                      <FormGroup>
                        <Label for="team">Team</Label>
                        <Input
                          id="team"
                          name="team"
                          type="select"
                          onChange={this.setInput}
                        >
                          <option value={''}>Please select</option>
                          {this.state.teams.map((type, index) => (
                            <option
                              key={index}
                              value={type.toLocaleLowerCase()}
                            >
                              {startCase(type)}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col md={12} xs={12}>
                      <FormGroup>
                        <Label className="mt-3">Excerpt:</Label>
                        <Input
                          name="excerpt"
                          type="textarea"
                          onChange={this.setInput}
                          value={this.state.excerpt}
                          disabled={this.state.loading}
                        />
                      </FormGroup>
                    </Col>

                    <Col md={12} xs={12}>
                      <FormGroup>
                        <Label className="mt-3">Job Description:</Label>
                        <ReactQuill
                          theme="snow"
                          value={this.state.description}
                          onChange={this.handleDescriptionChange}
                          readOnly={this.state.loading}
                          modules={{
                            toolbar: [
                              [{ header: [1, 2, 3, false] }],
                              ['bold', 'italic', 'underline', 'strike'],
                              [{ list: 'ordered' }, { list: 'bullet' }],
                              [{ indent: '-1' }, { indent: '+1' }],
                              ['link'],
                              ['clean'],
                              ['image'],
                              ['code-block'],
                              ['blockquote'],
                              ['code'],
                            ],
                          }}
                          placeholder="Write the job description here..."
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </form>
            </ModalBody>
            <ModalFooter>
              <Button
                color="success"
                disabled={this.state.loading}
                onClick={this.submit}
              >
                Create Job Listing{' '}
                {this.state.loading ? (
                  <span className="fas fa-spinner fa-spin"></span>
                ) : (
                  ''
                )}
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      );
    }
  }
);
